// extracted by mini-css-extract-plugin
module.exports = {"container":"Tarifs_container__3xkTi","abonnements":"Tarifs_abonnements__2HlEz","mobile":"Tarifs_mobile__wSPit"};